export default __webpack_public_path__ + "static/media/default-en.485f3996.mp3";